// extracted by mini-css-extract-plugin
export default {"svgRoot":"hFIgpF","svgButton":"jardUn"};